import { render, staticRenderFns } from "./summary-audio-sort.vue?vue&type=template&id=31b3d5d6&scoped=true"
import script from "./summary-audio-sort.vue?vue&type=script&lang=js"
export * from "./summary-audio-sort.vue?vue&type=script&lang=js"
import style0 from "./summary-audio-sort.vue?vue&type=style&index=0&id=31b3d5d6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b3d5d6",
  null
  
)

export default component.exports